import {LoaderProps} from './types'
import React from 'react'

const LoaderView = ({label}: LoaderProps) => <div className='loader'><div className='loaderLabel'>{label}</div></div>

export default LoaderView
